import { FC } from 'react';
import { Launch } from '@carbon/icons-react';
import { css } from '@emotion/css';

const iconClass = css`
  font-size: 16px;
  bottom: -2px;
  position: relative;
  margin-left: 4px;
`;

export const OpenInNewIcon: FC<React.PropsWithChildren<unknown>> = () => {
  return <Launch className={iconClass} />;
};
